<script>
import swal from "sweetalert2";
import VueAvatar from '@/app/components/vue-avatar/VueAvatar.vue';
import "sweetalert2/dist/sweetalert2.css";
import { mapState, mapActions, mapMutations } from "vuex";
import Modal from "@/components/Modal";
import AssignCompany from "@/app/components/AssignCompany.vue";
import axios from "axios";

export default {
  name: "Preference",
  components: {
    VueAvatar,
    AssignCompany
  },
  data() {
    return {
      showEditCompanyModal: false,
      rotation: 0,
      scale: 1,
      borderRadius: 200,
      profileEditMode: false,
      ganttViewMode: "day",
      ganttDayMode: "full-week",
      ganttCommentMode: "no-comment",
      ganttZoomMode: "few",
      showCurrency: true,
      timezones: [
        'Asia/Kathmandu',
        'Australia/Sydney',
        'Australia/Melbourne'
      ],
      // dropzoneOptions: {
      //   url: process.env.VUE_APP_BASE_URL + "/profile-picture",
      //   thumbnailWidth: 150,
      //   maxFilesize: 2,
      //   thumbnailWidth: 200,
      //   paramName: "profile_pic",
      //   headers: { Authorization: "Bearer " + this.$auth.getToken() },
      // },
      selects: {
        showCurrency: "",
        currency: [
          { value: "USD", label: "United states", symbol: "$" },
          { value: "AUD", label: "Australia", symbol: "$" },
          { value: "EUR", label: "Euro", symbol: "€" },
          { value: "GBP", label: "Pound Sterling", symbol: "£" },
          { value: "CAD", label: "Canada", symbol: "$" },
        ],
      },
      showCropper: false,
      base64Avatar: '',
    };
  },
  watch: {},
  computed: {
    ...mapState("user", ["profile", "banners"]),
    ...mapState("common", ["countries", "currencies"]),
    getCompanyName() {
      if (this.profile.company && this.profile.company.website) {
        const website = this.profile.company.website
        const matches = website.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i);
        const domain = matches && matches[1];  // domain will be null if no match is found
        return domain
      }
    },
    avatar() {
      if (
        this.profile &&
        this.profile.profile_pic &&
        this.profile.profile_pic.file_url != null
      ) {
        return (
          this.profile.profile_pic.file_url ||
          require("@/assets/img/brand/profile.png")
        );
      } else {
        return require("@/assets/img/brand/profile.png");
      }
    },
  },
  async mounted() {
    this.fetchCurrencies()
    this.fetchBanners();


  },
  methods: {
    ...mapActions("user", [
      "savePreference",
      "fetchUserInfoAction",
      "updateProfileInfo",
      "deleteBanner",
      "saveBanner",
      "fetchBanners",
    ]),
    ...mapMutations(["setGanttRender", "setLoading"]),
    ...mapMutations("user", ["setBanners"], ["setLoading"]),
    ...mapActions("common", ["fetchCurrencies"]),

    async getBase64FromUrl(url) {
      return new Promise(async (resolve, reject) => {
        try {
          const data = await fetch(url);
          const blob = await data.blob();

          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => {
            const base64data = reader.result;
            resolve(base64data);
          }

        } catch (e) {
          console.log(e)
          reject(e)
        }
      });

    },

    onAddBannerClicked() {
      let isAdding = this.banners.some((a) => {
        return a.id == null;
      });
      if (isAdding) {
        this.$snack.success("Please save banner first");
      } else {
        let banners = [...this.banners, { id: null }];
        this.setBanners(banners);
      }
    },
    async onGanttViewModeClicked($event) {
      try {
        await this.savePreference({
          user_id: this.profile.id,
          key: "GANTT_VIEW_MODE",
          value: $event.target.value,
        });

        await this.fetchUserInfoAction();
      } catch (e) {
        console.log(e);
      }
    },

    async onGanttDayModeClicked($event) {
      try {
        await this.savePreference({
          user_id: this.profile.id,
          key: "GANTT_DAY_MODE",
          value: $event.target.value,
        });

        await this.fetchUserInfoAction();
      } catch (e) {
        console.log(e);
      }
    },
    async onGanttCommentModeClicked($event) {
      try {
        await this.savePreference({
          user_id: this.profile.id,
          key: "GANTT_COMMENT_MODE",
          value: $event.target.value,
        });

        await this.fetchUserInfoAction();
      } catch (e) {
        console.log(e);
      }
    },

    async onGanttZoomModeClicked($event) {
      try {
        await this.savePreference({
          user_id: this.profile.id,
          key: "GANTT_ZOOM_MODE",
          value: $event.target.value,
        });

        await this.fetchUserInfoAction();
      } catch (e) {
        console.log(e);
      }
    },

    async onShowFinanceClicked($event) {
      this.setLoading(true);
      try {
        await this.savePreference({
          user_id: this.profile.id,
          key: "SHOW_FINANCE",
          value: $event.target.checked ? "1" : "0",
        });

        await this.fetchUserInfoAction();
        this.setLoading(false);
      } catch (e) {
        console.log(e);
      }
    },


    async onQuoteCalculationModeClicked($event) {
      this.setLoading(true);
      try {
        await this.savePreference({
          user_id: this.profile.id,
          key: "QUOTE_CALCULATION_INTERVAL",
          value: $event.target.checked ? "DAY" : "HOUR",
        });

        await this.fetchUserInfoAction();
        this.setLoading(false);
      } catch (e) {
        console.log(e);
      }
    },

    async onDemoProjectClicked($event) {
      try {
        await this.savePreference({
          user_id: this.profile.id,
          key: "DEMO_PROJECT",
          value: $event.target.checked ? "1" : "0",
        });

        //await this.fetchUserInfoAction()
        //if(this.route.name == "projects")
        window.location.reload();
      } catch (e) {
        console.log(e);
      }
    },

    onLogoutClicked() {
      // swal({
      //     title: "Are you sure to logout?",
      //     text: "Please click OK to proceed!",
      //     icon: "info",
      //     buttons: true,
      //     dangerMode: false,
      // })
      // .then((willDelete) => {
      //     if (willDelete) {
      //       this.$auth.logout({}).then(r => {
      //           this.$router.go('/')
      //       })
      //     }
      // });

      swal({
        title: "Are you sure to logout?",
        text: `Please click Logout to proceed!`,
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Logout",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$auth.logout({}).then((r) => {
            this.$router.go("/");
          });
        }
      });
    },
    async onCurrecyChanged() {
      try {
        await this.savePreference({
          user_id: this.profile.id,
          key: "CURRENCY",
          value: JSON.stringify(this.profile.currency),
        });
        await this.fetchUserInfoAction();
      } catch (e) {
        console.log(e);
      }
    },
    onSaveBannerClicked(banner) {
      this.saveBanner(banner)
        .then((res) => {
          this.fetchBanners();
        })
        .catch((err) => {
          this.$$toaster.error("Could not save banner info");
        });
    },

    // async onCompanyAssignSuccess() {
    //   this.showEditCompanyModal = false
    //   await this.fetchUserInfoAction()
    // },

    onBannerDeleteClicked(banner) {
      swal({
        title: "Are you sure to delete?",
        text: `Please click delete to proceed!`,
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Delete!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          if (banner.id == null) {
            let banners = this.banners.filter((b) => b.id != null);
            this.setBanners(banners);
          } else {
            this.deleteBanner(banner.id).then((r) =>
              this.fetchUserInfoAction()
            );
          }
        }
      });
    },
    _onSaveProfileClicked() {
      this.updateProfileInfo(this.profile).then((r) => {
        this.fetchUserInfoAction();
        this.profileEditMode = !this.profileEditMode;
      });
    },
    // _onFileAdded(file) {},
    // _onFileRemoved(file) {},
    // _onComplete(file, status, xhr) {
    //   this.uploading = false;

    //   if (file.errorMessage) {
    //     this.$snack.success(file.errorMessage);
    //   } else {
    //     let body = JSON.parse(xhr.response);
    //     this.fetchUserInfoAction();
    //   }
    // },
    // _onUploadClicked() {
    //   document.getElementsByClassName("dz-clickable")[0].click();
    // },
    async onShowCropperClick() {
      // this.setLoading(true)
      //  let config = {
      //   headers: {
      //     Authorization: "Bearer " + this.$auth.getToken(),
      //   },
      // };
      //  axios
      //   .get(process.env.VUE_APP_BASE_URL + "/v1/profile-picture-base-64", config )
      //   .then((res) => {
      //     if (!res.error) {
      //       this.base64Avatar = res.data.data
      //       this.setLoading(false)
      //       this.showCropper = !this.showCropper;
      //     }
      //   })
      //  .catch(er => {
      //       this.setLoading(false)
      //       this.$snack.success("Could not fetch base64 iamge");
      //        this.showCropper = !this.showCropper;
      //     });
      if (this.profile && this.profile.profile_pic && this.profile.profile_pic.file_url) {

        try {
          this.base64Avatar = await this.getBase64FromUrl(this.profile.profile_pic.file_url)
          this.showCropper = !this.showCropper;
        } catch (e) {
          console.log("error in base64", e)
          this.showCropper = !this.showCropper;
        }

      } else {
        this.showCropper = !this.showCropper;
      }

    },
    onUploadProfilePic() {
      var img = this.$refs.vueavatar.getImageScaled();
      img.crossOrigin = "*"
      img.toBlob((blob) => {
        const formData = new FormData();
        formData.append("profile_pic", blob, "avatar");
        this.setLoading(true);
        this.uploadProfileImage(formData);
      }, { crossOrigin: '*' });
    },
    uploadProfileImage(formData) {
      let config = {
        headers: {
          Authorization: "Bearer " + this.$auth.getToken(),
        },
      };
      axios
        .post(
          process.env.VUE_APP_BASE_URL + "/v1/profile-picture",
          formData,
          config
        )
        .then((res) => {
          if (!res.error) {
            this.setLoading(false);
            this.fetchUserInfoAction();
            this.showCropper = !this.showCropper;
          }
        });
    },
    onImageReady() {
      this.scale = 1;
      this.rotation = 0;
    },

    convertImgUrlToBase64(url) {
      let self = this;
      var image = new Image();
      image.setAttribute('crossOrigin', 'anonymous'); // use it if you try in a different origin of your web

      image.onload = function () {
        var canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;

        canvas.getContext('2d').drawImage(this, 0, 0);

        canvas.toBlob(
          function (blob) {
            var newImg = document.createElement("img"),
              url = URL.createObjectURL(blob);

            newImg.onload = function () {
              // no longer need to read the blob so it's revoked
              URL.revokeObjectURL(url);
            };

            newImg.src = url;
          },
          "image/jpeg",
          1
        );

        // If you ever stumble at 18 DOM Exception, just use this code to fix it
        // let dataUrl = canvas.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");
        let dataUrl = canvas.toDataURL("image/jpeg");
        console.log("cek inside url : ", url);

        if (url === backgroundImg) {
          self.assignImageBase64Background(dataUrl);
        } else {
          self.assignImageBase64(dataUrl);
        }
      };
      image.src = url;
    },

    assignImageBase64(img) {
      this.base64Avatar = img;
    },
  },
};
</script>

<style lang="scss" scoped>
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active below version 2.1.8 */
  {
  transform: translateX(-50px);
  opacity: 0;
}

.full-width {
  width: 100%;
}
</style>


<template>
  <div class="bg-white md__card--holder clearfix">
    <modal :show.sync="showEditCompanyModal">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">Edit Company</h5>
      </template>

      <AssignCompany @closeClicked="showEditCompanyModal = false" @saveClicked="alert('ddd')" :data="profile.company" />
    </modal>
    <div>
      <!-- Card header -->
      <div class="card-header d-flex align-items-center chat-header-title navbar-height bg-navy rounded-0">
        <!-- :class="{'blue-class':($route.name == 'projects'), 'green-class':($route.name == 'tasks.home'), 'yellow-class':($route.name == 'timesheet.home')}" -->
        <!-- Title -->
        <!-- <div class="col px-0">
          <h4 class="h3 mb-0">Profile</h4>
        </div> -->
        <div class="d-block">
          <div class="header-title">Profile <span class="bracket"> { </span></div>
        </div>
        <div class="d-block ml-auto">
          <base-button v-if="profile.role && profile.role.name != 'guest'" type="default" outline size="sm"
            @click="onLogoutClicked">
            <span class="btn-inner--text">
              Logout
            </span>

            <span class="btn-inner--icon ml-1">
              <i class="far fa-sign-out"></i>
            </span>
          </base-button>
        </div>
      </div>
      <!-- <div class="card-header d-flex align-items-center">
        <div class="col">
          <div class="text-center full-width">
            <a
              href="timesheet.html"
              class="btn btn-sm btn-warning"
              style="width: 100%"
              >Timesheet</a
            >
          </div>
        </div>
      </div> -->
    </div>
    <form class="card shadow-none tf__edit--userinfo box-s border-0 rounded-0" v-if="profile.role && profile.role.name != 'guest'">
      <div class="card-header d-flex align-items-center justify-content-between mb-0 py-3 border-0">
        <div class="">
          <!-- <div class="content_center"> -->
          <div class="img_wrapper img-wrapper--avatar p-0 rounded-circle  position-relative">
            <div class="img_box d-flex align-items-center justify-content-center h3 lh-1 mb-0 text-body bg-light w-100 h-100 rounded-circle overflow-hidden">
              <img alt="Circle image" class="img-fluid shadow mh-100 mw-100" v-if="avatar" :src="avatar" />
            </div>
            <!-- _onUploadClicked -->
            <button type="button" @click="onShowCropperClick" class="btn btn-add bg-white">
              <i class="fas fa-plus"></i>
            </button>
          </div>
          <!-- </div> -->
          <!-- div avatar editor start -->
          <modal :show="showCropper">
            <div v-if="showCropper" class="cropper">
              <div class="img_box">
                <vue-avatar :width="400" :height="400" :rotation="rotation" :borderRadius="borderRadius" :scale="scale"
                  ref="vueavatar" :accept="'image/*'" :image="base64Avatar"
                  @vue-avatar-editor:image-ready="onImageReady">
                </vue-avatar>
                <br />
                <label class="zoom">
                  Zoom : {{ scale }}x
                  <br />
                  <input type="range" min="1" max="5" step="0.02" v-model="scale" />
                </label>
                <br />
                <button class="btn btn-sm btn-warning" type="button" v-on:click="onUploadProfilePic">
                  Upload profile picture
                </button>
                <br />
                <!-- <img ref="image" /> -->
              </div>
              <base-button type="link" class="ml-auto" @click="showCropper = false">Cancel</base-button>
            </div>
            <!-- <div class="tf__content-box" v-if="uploading">
                      <div class="loading">
                        <i class="fas fa-spinner fa-pulse"></i>
                      </div>
                </div> -->
          </modal>
          <!-- div avatar editor end-->
        </div>
        <div class="">
          <button v-if="!profileEditMode" @click="profileEditMode = !profileEditMode" class="btn btn-sm btn-outline-light">
            <!-- <span class="icon-sml">
              <i class="fas fa-edit"></i>
              Edit info
            </span> -->
            
	          <span class="btn-inner--text">Edit info</span>
            <span class="btn-inner--icon  ml-1"><i class="far fa-edit"></i></span>
          </button>
          <button class="btn btn-sm btn-warning tf__save" v-if="profileEditMode" type="button"
            @click="_onSaveProfileClicked">
            <!-- <span class="icon-sml">
              <i class="fas fa-save"></i>
              Save
            </span> -->
            
	          <span class="btn-inner--text">Save</span>
            <span class="btn-inner--icon  ml-1"><i class="far fa-save"></i></span>
          </button>
        </div>
      </div>
      <!-- Card Body -->
      <div class="card-body bg-light-grey" v-if="profile.role.name != 'guest'">
        <div v-if="profileEditMode" class=" bg_disabled mb-0">
          <div class="form-group">
            <!-- <label class="d-block"><small>First Name</small></label> -->
              <small class="text-uppercase text-muted small-68 label-custom-sm font-weight-bold mb-2 d-block">First Name</small>
            <input type="text" class="form-control" v-model="profile.first_name" :disabled="!profileEditMode" />
          </div>
          <div class="form-group">
            <!-- <label class="d-block"><small>Last Name</small></label> -->
             <small class="text-uppercase text-muted small-68 label-custom-sm font-weight-bold mb-2 d-block">Last Name</small>
            <input type="text" class="form-control" v-model="profile.last_name" :disabled="!profileEditMode" />
          </div>
          <div class="form-group">
            <!-- <label class="d-block"><small>Country</small></label> -->
             <small class="text-uppercase text-muted small-68 label-custom-sm font-weight-bold mb-2 d-block">Country</small>
            <el-select :readonly="true" v-model="profile.country" class="select-danger w-100 " placeholder=""
              :disabled="!profileEditMode">
              <el-option v-for="option in countries" :value="option" :label="option" :key="option"
                class="select-danger" />
            </el-select>

          </div>
          <div class="form-group">
            <!-- <label class="d-block"><small>Timezone</small></label> -->
            <small class="text-uppercase text-muted small-68 label-custom-sm font-weight-bold mb-2 d-block">Timezone</small>
            <el-select :readonly="true" v-model="profile.timezone" class="select-danger w-100 " placeholder=""
              :disabled="!profileEditMode">
              <el-option v-for="option in timezones" :value="option" :label="option" :key="option"
                class="select-danger" />
            </el-select>

          </div>

          <div class="form-group">
            <!-- <label class="d-block"><small>City</small></label> -->
             <small class="text-uppercase text-muted small-68 label-custom-sm font-weight-bold mb-2 d-block">City</small>
            <input type="text" class="form-control" v-model="profile.city" :disabled="!profileEditMode" />
          </div>
          <div class="form-group">
            <!-- <label class="d-block"><small>Email</small></label> -->
            <small class="text-uppercase text-muted small-68 label-custom-sm font-weight-bold mb-2 d-block">Email</small>
            <input type="text" class="form-control" :readonly="true" v-model="profile.email"
              :disabled="!profileEditMode" />
          </div>
          <div class="form-group">
            <!-- <label class="d-block"><small v-if="profileEditMode">Password</small></label> -->
             <small class="text-uppercase text-muted small-68 label-custom-sm font-weight-bold mb-2 d-block">Password</small>
            <input type="password" class="form-control" v-model="profile.password" :disabled="!profileEditMode" />
          </div>

        </div>
        <div v-if="!profileEditMode" class=" bg_disabled mb-0">
          <ul class="list-unstyled mb-0">
            <li v-if="profile.first_name">
              <small class="text-uppercase text-muted small-68 label-custom-sm font-weight-bold">First Name</small>
              <input class="w-100 form-control border-0 p-0 mb-4 bg-transparent h-1 font-weight-bold h-auto form-control-lg text-primary " type="text" v-model="profile.first_name" :disabled="!profileEditMode" />
            </li>
            <li v-if="profile.last_name">
              <small class="text-uppercase text-muted small-68 label-custom-sm font-weight-bold">Last Name</small>
              <input class="w-100 form-control border-0 p-0 mb-4 bg-transparent h-1 font-weight-bold h-auto form-control-lg text-primary" type="text" :value="profile.last_name" :disabled="!profileEditMode" />
            </li>
            <li v-if="profile.country">
              <small class="text-uppercase text-muted small-68 label-custom-sm font-weight-bold">Country</small>
              <el-select :readonly="true" v-model="profile.country" class="select-danger w-100 select--disabled" placeholder=""
                :disabled="!profileEditMode">
                <el-option v-for="option in countries" :value="option" :label="option" :key="option"
                  class="select-danger" />
              </el-select>
            </li>
            <li v-if="profile.timezone">
              <small class="text-uppercase text-muted small-68 label-custom-sm font-weight-bold">Timezone</small>
              <el-select :readonly="true" v-model="profile.timezone" class="select-danger w-100 select--disabled" placeholder=""
                :disabled="!profileEditMode">
                <el-option v-for="option in timezones" :value="option" :label="option" :key="option"
                  class="select-danger" />
              </el-select>
            </li>
            <li v-if="profile.city" >
              <small class="text-uppercase text-muted small-68 label-custom-sm font-weight-bold">City</small>
              <input class="w-100 form-control border-0 p-0 mb-4 bg-transparent h-1 font-weight-bold h-auto form-control-lg text-primary" type="text" v-model="profile.city" :disabled="!profileEditMode" />
            </li>
            <li v-if="profile.email">
              <small class="text-uppercase text-muted small-68 label-custom-sm font-weight-bold">Email</small>
              <input class="w-100 form-control border-0 p-0 mb-4 bg-transparent h-1 font-weight-bold h-auto form-control-lg text-primary" type="text" :readonly="true" v-model="profile.email" :disabled="!profileEditMode" />
            </li>
            <!--  <li>
               <small v-if="profileEditMode">Password</small>
              <input
                type="password"
                v-model="profile.password"
                :disabled="!profileEditMode"
              />
            </li> -->
          </ul>
        </div>
      </div>
    </form>
    <div class="card tf__banner--edit" v-if="profile.role.name == 'super_admin'">
      <div class="card-header d-flex align-items-center">
        <div class="col px-0">
          <h4 class="h3 mb-0">Banners Text</h4>
        </div>
        <div class="text-right">
          <button @click="onAddBannerClicked" class="btn btn-sm btn-success">
            <i class="fas fa-plus pr-1"></i>Add New
          </button>
        </div>
      </div>
      <div class="card-body">
        <!-- first text area -->
        <article v-for="(banner, ind) in banners" :key="ind" class="mb-2">
          <textarea v-model="banner.banner_text"></textarea>
          <div class="text-right">
            <button @click="onBannerDeleteClicked(banner)" class="btn btn-sm btn-danger">
              <i class="fas fa-trash pr-1"></i>Delete
            </button>
            <button @click="onSaveBannerClicked(banner)" class="btn btn-sm btn-warning">
              <i class="fas fa-save pr-1"></i>Save
            </button>
          </div>
        </article>
        <!-- first text area -->
      </div>
      <!-- <div class="card-footer">
        <div class="text-right">
          <button class="btn btn-sm btn-success">
            <i class="fas fa-plus pr-1"></i>Add
          </button>
        </div>
      </div>-->
    </div>
    <div class="" v-if="profile.role.name != 'guest' && false">
      <!-- Card header -->

      <div class="card-header" v-if="profile.role.name == 'admin'">
        <div class="row align-items-center justify-content-between">
          <!-- Title -->
          <div class="col-md-6">
            <h4 class="h3 mb-0">Payment</h4>

          </div>
          <div class="col-md-6 text-right">
            <button class="btn btn-sm btn-info">
              <span class="icon-sml">
                <i class="fas fa-edit"></i>
                Connect Stripe
              </span>
            </button>
          </div>
        </div>
      </div>


      <div class="card-header">
        <div class="row align-items-center justify-content-between">
          <!-- Title -->
          <div class="col-md-6">
            <h4 class="h3 mb-0">Company</h4>

          </div>
          <div class="col-md-6 text-right">
            <button class="btn btn-sm btn-info" @click="showEditCompanyModal = true">
              <span class="icon-sml">
                <i class="fas fa-edit"></i>
                Edit info
              </span>
            </button>
          </div>
          <div class="col-md-12">
            <div class="card-body">
              <div class="row align-items-center">

                <div class="col ml-0" v-if="profile.company">
                  <h4 class="card-title mb-0">{{ profile.company.website }}</h4>
                  <!-- <span class="h5 text-muted mb-0">{{ getCompanyName }}</span> -->
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="card-body" v-if="profile.role.name != 'payer' && false">
        <h4 class="card-title mb-3">Account</h4>
        <ul class="nav tabPanel mb-3" role="tablist">
          <li>
            <a href="#payBills" class="custom-control custom-radio custom-control-inline" role="tab" data-toggle="tab">
              <input id="finaceRadio" name="finaceRadio" class="custom-control-input" type="checkbox" />
              <label class="custom-control-label" for="finaceRadio">$2 per project per month</label>
            </a>
          </li>
          <li>
            <a href="#workBills" class="custom-control custom-radio custom-control-inline" role="tab" data-toggle="tab">
              <input id="fileLimitRadio" name="fileLimitRadio" class="custom-control-input" type="checkbox" />
              <label class="custom-control-label" for="fileLimitRadio">$10 per 1GB per month</label>
            </a>
          </li>
        </ul>
        <div class="tab-content borderRadius-3">
          <div id="payBills" role="tabpanel" class="col-sm-12 tab-pane fade active show">
            <!-- <div class="form-group mb-4">
              <label>Estimated monthly cost</label>
              <input
                type="text"
                class="form-control"
                placeholder="$XXX per month"
              />
            </div> -->
            <div class="form-group mb-4">
              <!-- <label>Add/Edit Credit Card</label>  -->
              <div class="text-left">
                <button class="btn btn-sm btn-success w-100">
                  <span class="icon-sml">
                    <i class="fas fa-plus"></i>
                    Add/Edit credit card
                  </span>
                </button>

                </button>
              </div>
              <div class="text-left mt-2">
                <button class="btn btn-sm btn-warning w-100">
                  <span class="icon-sml">
                    <i class="fas fa-eye"></i>
                    View statements
                  </span>
                </button>
              </div>
            </div>
            <!-- currency -->
            <form class="mt-1" v-if="
              profile.role.name == 'admin' ||
              profile.role.name == 'super_admin'
            ">
              <small>Currency</small>
              <el-select v-model="resource.currency" class="select-danger w-100" placeholder="Select Currency"
                value-key="id" @change="onCurrecyChanged">
                <el-option v-for="option in currencies" :value="option" :label="option.code + ' (' + option.symbol + ')'"
                  :key="option.id" class="select-danger" />
              </el-select>

              <transition name="slide-fade">
                <div v-if="profile.currency" class="mt-3">
                  <div class="row">
                    <div class="col">
                      <span class="h5">{{ profile.currency.label }}</span>
                      <small>({{ profile.currency.symbol }}-{{
                          profile.currency.value
                      }})</small>
                    </div>
                    <!-- <div class="col">
                    <span class="h5">UTC+10</span>
                    <small>
                      (AEST)
                    </small>
                </div>-->
                  </div>
                </div>
              </transition>
            </form>
            <!-- end of currency -->
          </div>
          <div id="workBills" role="tabpanel" class="col-sm-12 tab-pane fade">
            <div class="custom-control custom-radio mb-3">
              <input id="workfinanceRadio" name="workfinanceRadio" class="custom-control-input" type="checkbox" />
              <label class="custom-control-label" for="workfinanceRadio">Finance Active</label>
            </div>
            <div class="custom-control custom-radio mb-3">
              <input id="workfileLimitRadio" name="workfileLimitRadio" class="custom-control-input" type="checkbox" />
              <label class="custom-control-label" for="workfileLimitRadio">File Uploads</label>
            </div>
          </div>
        </div>
        <div class="d-flex mb-2" v-if="false">
          <div class="col px-0">
            <label class="form-control-label mr-4">Show Billing</label>
          </div>
          <label class="col-auto custom-toggle px-0">
            <input id="billing" type="checkbox" data-toggle="collapse" data-target="#showBilling" aria-expanded="false"
              value="billing" name="billing" class="custom-control-input" />
            <!-- <input type="checkbox"> -->
            <span class="custom-toggle-slider rounded-circle" data-label-off="OFF" data-label-on="ON" />
          </label>
        </div>
      </div>
      <div class="card-body d-none">
        <div id="invtform1" class="collapse">
          <!-- <div class="card-body">
            <div class="row">
              <div class="col-sm-12 form-group">
                <label>Company Name</label>
                <input type="text" class="form-control" name="fname" />
              </div>
              <div class="col-sm-12 form-group">
                <label>Email</label>
                <input
                  type="email"
                  class="form-control"
                  name="email"
                  placeholder="Enter email..."
                />
              </div>
              <div class="col-sm-12 form-group">
                <button
                  class="btn btn-success btn-lg btn-block"
                  type="button"
                  data-toggle="collapse"
                  data-target="#invtform1"
                  role="button"
                  aria-expanded="false"
                  aria-controls="invtform1"
                >
                  Invite
                </button>
              </div>
            </div>
          </div> -->
          <div class="card-body">
            <div class="form-row">
              <div class="col-md-12">
                <label>Role</label>
              </div>
              <div class="col-md-12">
                <div class="custom-control custom-radio mb-3 custom-control-inline">
                  <input id="admin" name="custom-radio-2" class="custom-control-input" checked type="radio" />
                  <label class="custom-control-label" for="admin">Admin</label>
                </div>
                <div class="custom-control custom-radio mb-3 custom-control-inline">
                  <input id="finance" name="custom-radio-2" class="custom-control-input" type="radio" />
                  <label class="custom-control-label" for="finance">Finance</label>
                </div>
                <div class="custom-control custom-radio mb-3 custom-control-inline">
                  <input id="team" name="custom-radio-2" class="custom-control-input" type="radio" />
                  <label class="custom-control-label" for="team">Team Member</label>
                </div>
                <div class="custom-control custom-radio mb-3 custom-control-inline">
                  <input id="payer" name="custom-radio-2" class="custom-control-input" type="radio" />
                  <label class="custom-control-label" for="payer">Payer</label>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>



    <div class="card" v-if="profile.role.name != 'guest' && false">
      <!-- Card header -->
      <div class="card-header d-flex align-items-center">
        <!-- Title -->
        <!-- Title -->
        <div class="col px-0">
          <h4 class="h3 mb-0">Demo Project</h4>
        </div>
        <div class="text-right">
          <label class="col-auto custom-toggle px-0">
            <input id="demoProject" type="checkbox" @click="onDemoProjectClicked" :checked="profile.demoProject == '1'"
              name="dempProject" class="custom-control-input" />
            <!-- <input type="checkbox"> -->
            <span class="custom-toggle-slider rounded-circle" data-label-off="OFF" data-label-on="ON" />
          </label>
        </div>
      </div>
      <!-- Card Body -->
      <div class="card-body">
        <div class=" bg_disabled mb-0">
          <small>You can assist Bracket with updates you want considered to our
            project roadmap in the Demo project.</small>
        </div>
      </div>
    </div>
    <div class="card shadow-none border-0 rounded-0 bg-transparent">
      <!-- Card header -->
      <div class="card-header border-0 rounded-0 bg-transparent pt-3">
        <!-- Title -->
        <h6 id="PinchFilter" class="mb-0">Gantt Chart</h6>
      </div>
      <!-- Card Body-->
      <div class="card-body pt-2">
        <div class="modalfilter-row">
          <div class="custom-control custom-radio custom-control-inline align-items-center justify-content-center">
            <input id="projectsGanttDays" type="radio" name="ganttView" class="custom-control-input" value="day"
              @click="onGanttViewModeClicked" v-model="profile.ganttViewMode" />
            <label class="custom-control-label custom-control--label-custom lh-1 h-auto" for="projectsGanttDays">Days</label>
          </div>
          <div class="custom-control custom-radio custom-control-inline align-items-center justify-content-center">
            <input id="projectsGanttMonth" type="radio" value="month" name="ganttView" v-model="profile.ganttViewMode"
              @click="onGanttViewModeClicked" class="custom-control-input" />
            <label class="custom-control-label custom-control--label-custom lh-1 h-auto" for="projectsGanttMonth">Month</label>
          </div>
          <div class="custom-control custom-radio custom-control-inline align-items-center justify-content-center">
            <input id="projectsGanttYear" type="radio" value="year" name="ganttView" @click="onGanttViewModeClicked"
              v-model="profile.ganttViewMode" class="custom-control-input" />
            <label class="custom-control-label custom-control--label-custom lh-1 h-auto" for="projectsGanttYear">Year</label>
          </div>
        </div>
        <!-- for days month  -->
        <div class="modalfilter-row mt-3" v-if="false">
          <div class="custom-radio custom-control-inline mr-0 w-100">
            <input id="projectsZoom1" type="radio" value="few" v-model="profile.ganttZoomMode" name="projectsZoom"
              @click="onGanttZoomModeClicked" class="custom-control-input" />
            <label class="custom-control-label custom-control--label-custom lh-1 h-auto" for="projectsZoom1">Few</label>
          </div>

          <div class="custom-radio custom-control-inline mr-0 w-100">
            <input id="projectsZoom2" type="radio" value="many" name="projectsZoom" v-model="profile.ganttZoomMode"
              @click="onGanttZoomModeClicked" class="custom-control-input" />
            <label class="custom-control-label custom-control--label-custom " for="projectsZoom2">Many</label>
          </div>
        </div>
        <div v-if="profile.ganttViewMode == 'day'" class="modalfilter-row mt-3">
          <div class="custom-radio custom-control-inline mr-0 w-100 flex-wrap align-items-center">
            <label class="form-control-label mr-auto text-uppercase form-control--small text-primary lh-1 mb-0">Display </label>
            <div class="custom-control custom-radio custom-control-inline align-items-center justify-content-center mr-2">
              <input id="dayModeFullWeek" type="radio" value="full-week" name="ganttDay" v-model="profile.ganttDayMode"
                @click="onGanttDayModeClicked" class="custom-control-input" />
              <label class="custom-control-label custom-control--label-custom lh-1 h-auto" for="dayModeFullWeek">Full week</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline align-items-center justify-content-center mr-0">
              <input id="dayModeWorkDays" type="radio" value="work-days" name="ganttDay" v-model="profile.ganttDayMode"
                @click="onGanttDayModeClicked" class="custom-control-input" />
              <label class="custom-control-label custom-control--label-custom lh-1 h-auto" for="dayModeWorkDays">Workdays</label>
            </div>
          </div>
        </div>
        <div class="modalfilter-row mt-2" v-if="false">
          <div class="custom-radio custom-control-inline">
            <label class="form-control-label mr-4">Show</label>
            <div class="custom-control custom-radio custom-control-inline">
              <input id="firstComment" type="radio" value="task-title" name="ganttComment"
                v-model="profile.ganttCommentMode" @click="onGanttCommentModeClicked" class="custom-control-input" />
              <label class="custom-control-label custom-control--label-custom" for="firstComment">Task title</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input id="lastComment" type="radio" value="last-comment" name="ganttComment"
                v-model="profile.ganttCommentMode" @click="onGanttCommentModeClicked" class="custom-control-input" />
              <label class="custom-control-label custom-control--label-custom" for="lastComment">Last comment</label>
            </div>

          </div>
        </div>
        <div class="modalfilter-row mt-2" v-if="false">
          <div class="custom-radio custom-control-inline">
            <label class="form-control-label mr-4">Show Finance</label>
            <label class="custom-toggle">
              <input id="ShowFinance" type="checkbox" value="1" name="ShowFinance" @click="onShowFinanceClicked"
                :checked="profile.showFinance == '1'" class="custom-control-input" />
              <!-- <input type="checkbox"> -->
              <span id="showRadio" class="custom-toggle-slider rounded-circle" data-label-off="OFF"
                data-label-on="ON" />
            </label>
          </div>
        </div>

        <div class="modalfilter-row mt-3">
          <div class="custom-radio custom-control-inline mr-0 w-100">
            <label class="form-control-label mr-auto text-uppercase form-control--small text-primary mb-0">Use Days For Quote Calculation</label>
            <label class="custom-toggle">
              <input id="quoteCalculationInterval" type="checkbox" name="ShowFinance"
                @click="onQuoteCalculationModeClicked" :checked="profile.quoteCalculationInterval == 'DAY'"
                class="custom-control-input" />
              <!-- <input type="checkbox"> -->
              <span id="showRadio" class="custom-toggle-slider rounded-circle" data-label-off="OFF"
                data-label-on="ON" />
            </label>
          </div>
        </div>
      </div>
      <div class="card-footer border-light-grey text-left rounded-0 bg-transparent">
        <div class="billing-section">
          <a @click="$router.push({ name: 'billing.home' }).catch(e => { })"><button class="btn btn-secondary btn-sm"> Billing
              Information</button></a>
        </div>

      </div>
    </div>
  </div>
</template>

<style scoped>
@media only screen and (max-width: 768px) {
  .chat-header-title {
    padding-top: 2rem;
  }
}

.chat-header-title {
  padding: 0.7rem 1.5rem;
}
.label-custom-sm{
  letter-spacing: .04em;
}

/* .chat-header-title.green-class {
  border-bottom: 5px solid #fbdf43;
}

.chat-header-title.yellow-class {
  border-bottom: 5px solid #fbdf43;

} */

.chat-header-title h4 {
  color: #fff;
  font-size: 24px;
}

.header-title {
  font-size: 30px;
  font-weight: bold;
  color: #ffff;
  line-height: 1;
  /* margin-bottom: -10px;
  margin-top: 10px; */
  margin-top: 0;
  margin-bottom: 0;
}

.bracket {
  font-size: 30px;
  color: #fddf43;
}

.img-wrapper--avatar{
  height: 3.4rem;
width: 3.4rem;
box-shadow: 0 0 15px 1px #0004;
}

.form-control--small{
  font-size: 80%;
}

.custom-control--label-custom::before,
.custom-control--label-custom::after{
  top:0;
}

.custom-control--label-custom::before {
	/* border-color: #d0d5e3;
	background-color: #e0e4ef; */
	border-color: #d0d5e3;
	background-color: #f0f1f6;
}


</style>
<style>
.select--disabled input[disabled]{
 border: none !important;
    padding: 0 !important;
    margin-bottom: 12px !important;
    font-weight: 600 !important;
    display: block !important;
    background-color: transparent !important;
    height: 20px !important;
    color:#18234d !important;
    font-size: 1rem !important;
}

.select--disabled input[disabled] + .el-input__suffix {
      display: none !important;
  
}

.select--disabled input[disabled]:hover,
.select--disabled input[disabled]:focus,
.select--disabled input[disabled]:active{
      outline: none !important;
      border: none !important;
}

.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
	border-color: #0000a4;
}

.custom-control-input:checked ~ .custom-control-label::before {
	color: #fff;
	border-color: #0000a4;
	background-color: #0000a4;
	box-shadow: none;
}

.custom-toggle input:checked + .custom-toggle-slider::after {

	color: #fff;


}

.custom-toggle input:checked + .custom-toggle-slider::before {
	background: #fff;
}

.custom-toggle input:checked + .custom-toggle-slider {
	border: 1px solid #0000a4;
  background-color: #0000a4;
}
.el-input__inner{
  color: #18234d;
    /* color: green; */
}

</style>